import React, { useState, useEffect, useCallback } from 'react';
import '../styles/team.css';

const teamMembers = [
  {
    id: 'ceo',
    name: 'M. Yiewou Kevin',
    roleLabel: 'Président Directeur Général',
    photo: '/assets/team/kevin.jpeg',
    photoPosition: '18% center',
    accent: 'navy',
    featured: true,
    icon: 'leadership'
  },
  {
    id: 'frontend',
    name: 'M. James Douanla',
    roleLabel: 'Project Manager - Développeur Frontend',
    photo: '/assets/team/james.jpg',
    photoPosition: 'center top',
    accent: 'red',
    icon: 'frontend'
  },
  {
    id: 'backend',
    name: 'M. Marcel Ngom',
    roleLabel: 'Développeur Backend - Administrateur de BD',
    photo: '/assets/team/marcel.png',
    photoPosition: '72% center',
    accent: 'blue',
    icon: 'backend'
  },
  {
    id: 'fullstack',
    name: 'M. Ulrich Sitamze',
    roleLabel: 'Ingénieur DevOps',
    photo: '/assets/team/zeus.png',
    photoPosition: 'center top',
    accent: 'purple',
    icon: 'fullstack'
  },
  // {
  //   id: 'fullstack',
  //   name: 'M. Ngounou Arlane',
  //   roleLabel: 'Développeur Full Stack',
  //   photo: '/assets/team/arlane.png',
  //   photoPosition: 'center top',
  //   accent: 'purple',
  //   icon: 'fullstack'
  // }
];

const RoleIcon = ({ type }) => {
  const icons = {
    leadership: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ),
    backend: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
      </svg>
    ),
    frontend: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
    fullstack: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
      </svg>
    )
  };
  return icons[type] || null;
};

const TeamModal = ({ member, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  if (!member) return null;

  return (
    <div className="team-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="team-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="team-modal-name"
      >
        <button type="button" className="team-modal-close" onClick={onClose} aria-label="Fermer">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="team-modal-photo-wrap">
          <img
            src={member.photo}
            alt={member.name}
            className="team-modal-photo"
            style={{ objectPosition: member.photoPosition || 'center top' }}
          />
        </div>

        <div className="team-modal-info">
          <div className="team-modal-role-badge">
            <span className="team-role-icon"><RoleIcon type={member.icon} /></span>
            {member.roleLabel}
          </div>
          <h2 id="team-modal-name">{member.name}</h2>
        </div>
      </div>
    </div>
  );
};

const TeamSection = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const closeModal = useCallback(() => setSelectedMember(null), []);

  return (
    <section id="team" className="team-section">
      <div className="team-inner">
        <div className="section-header">
          <span className="section-label">Notre équipe</span>
          <h2>Les talents derrière Nexus Africa Solutions</h2>
          <p>
            Une équipe camerounaise pluridisciplinaire — direction, ingénierie backend, frontend et full stack — au service de vos projets les plus exigeants.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <article
              key={member.id}
              className={`team-card team-accent-${member.accent} ${member.featured ? 'team-card-featured' : ''}`}
              style={{ animationDelay: `${index * 80}ms` }}
              onClick={() => setSelectedMember(member)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedMember(member);
                }
              }}
              role="button"
              tabIndex={0}
              aria-label={`Voir ${member.name}, ${member.roleLabel}`}
            >
              <div className="team-card-glow" />
              <div className="team-avatar">
                <img
                  src={member.photo}
                  alt=""
                  className="team-avatar-img"
                  loading="lazy"
                  style={{ objectPosition: member.photoPosition || 'center top' }}
                />
                {member.featured && <span className="team-avatar-badge">PDG</span>}
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <div className="team-role">
                  <span className="team-role-icon"><RoleIcon type={member.icon} /></span>
                  {member.roleLabel}
                </div>
              </div>
              {member.featured && (
                <p className="team-featured-text">
                  Vision stratégique, pilotage des opérations et excellence technique au cœur de chaque mission Nexus.
                </p>
              )}
            </article>
          ))}
        </div>
      </div>

      {selectedMember && (
        <TeamModal member={selectedMember} onClose={closeModal} />
      )}
    </section>
  );
};

export default TeamSection;
